
import React from "react";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

interface WorkoutNotesProps {
  notes: string;
  handleNotesChange: (notes: string) => void;
}

export function WorkoutNotes({ notes, handleNotesChange }: WorkoutNotesProps) {
  const handleNotesInput = (value: string) => {
    handleNotesChange(value);
    toast.success("Notes updated", {
      position: "bottom-right",
      duration: 1500,
    });
  };

  return (
    <div className="mt-4">
      <Input
        placeholder="Add workout notes here..."
        value={notes || ""}
        onChange={(e) => handleNotesInput(e.target.value)}
        className="border-dashed border-white/20 bg-transparent text-white w-full rounded-md transition-colors duration-200"
      />
    </div>
  );
}
